import * as R from 'ramda'
import moment from 'moment'
import { formatDate } from 'commons/date'
import { useSelector } from 'react-redux'

export const PlanId = {
  FREE_TRIAL: 'free',
  FREE_TIER: 'free_tier',
  PHYSICAL_WEB_STARTER_PACK: 'annual_starter_pack_1',
}

export const RecurringPlanPrice = {
  [PlanId.PHYSICAL_WEB_STARTER_PACK]: 300,
}

export const isPlanFreeTrialByPlanId = R.equals(PlanId.FREE_TRIAL)
export const isPhysicalWebStarterPackByPlanId = R.equals(
  PlanId.PHYSICAL_WEB_STARTER_PACK,
)
export const isPlanFreeTierByPlanId = R.equals(PlanId.FREE_TIER)

export const PlanPriceType = {
  MONTHLY: 'monthly',
  ANNUAL: 'annual',
}

export const getPlanFrequencyByPlanId = R.ifElse(
  R.includes(PlanPriceType.ANNUAL),
  R.always(12),
  R.always(1),
)

export const isUpgradePlan = ({
  currentPlan,
  nextPlan,
  isPlaceExpired = false,
}) => {
  if (isPlaceExpired) return true
  const nextPlanPricePerNotification =
    R.prop('price', nextPlan) / R.prop('notesQuantity', nextPlan)
  const currentPlanPricePerNotification =
    R.prop('price', currentPlan) / R.prop('notesQuantity', currentPlan)

  if (currentPlanPricePerNotification === 0) return true
  if (nextPlanPricePerNotification === 0) return false
  if (nextPlanPricePerNotification === currentPlanPricePerNotification) {
    return (
      R.prop('notesQuantity', nextPlan) >= R.prop('notesQuantity', currentPlan)
    )
  }

  return nextPlanPricePerNotification < currentPlanPricePerNotification
}

export const isDowngradePlan = ({ currentPlan, nextPlan, isPlaceExpired }) => {
  return !isUpgradePlan({ currentPlan, nextPlan, isPlaceExpired })
}

export const getPlanType = R.compose(
  R.cond([
    [R.includes(PlanPriceType.ANNUAL), R.always(PlanPriceType.ANNUAL)],
    [R.T, R.always(PlanPriceType.MONTHLY)],
  ]),
)

export const hasPlanEnded = ({ subscription }) => {
  const endsPlanAt = R.prop('endsAt', subscription)
  return endsPlanAt && moment().isAfter(endsPlanAt)
}

export const useNextPlan = () => {
  return useSelector(R.path(['place', 'nextSubscription', 'plan']))
}

export const isFreeTierOrFreeTrialPlanByPlanId = (planId) => {
  return R.includes(planId, [PlanId.FREE_TIER, PlanId.FREE_TRIAL])
}

export const getExpireDatePlanByPlanType = (planType, startFrom) => {
  return formatDate(
    moment(startFrom || moment()).add(
      1,
      planType === PlanPriceType.MONTHLY ? 'months' : 'years',
    ),
  )
}
